import React, {memo, useEffect, useState} from "react";
import {Head, Tree} from "../../components";
import Container from "@mui/material/Container";
import {Box, Tooltip} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {connect, useDispatch, useSelector} from "react-redux";
import Button from "@mui/material/Button";
import {Paper} from "@mui/material";
import { Loading} from './../../components'
import CurrencyFormat from "react-currency-format";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import SelectProduct from "../../components/selectProducts/selectProduct";
import IconButton from "@mui/material/IconButton";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import moment from "moment-jalaali";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import SortIcon from "@mui/icons-material/Sort";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Chip from "@mui/material/Chip";
import {FETCH_NODES, TOGGLE_CHECKED, TOGGLE_EXPANDED} from "../../types";
import {treeAction} from "../../actions";

var jalaali = require('jalaali-js')


const Discount = (props) => {

    const {authReducer} = props;

    const initStat = {
        status: 1,
        title: '',
        link: '',
        products: [],
        form: "item_product_update",
        order: null,
    }

    const [form, setForm] = useState(initStat);
    const [data, setData] = useState([]);
    const [discountId, setDiscountId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(false);
    const [productId, setProductId] = useState([]);

    const productReducer = useSelector((state) => state.productReducer)

    const tree = useSelector((state) => state.treeReducer)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch({type: TOGGLE_CHECKED, payload: []});
        dispatch({type: TOGGLE_EXPANDED, payload: []});
        dispatch({type: FETCH_NODES, payload: []});
        handleRequest()
        handleGet()
    }, []);

    const handleRequest = () => {
        dispatch(treeAction.productCategories())
    }
    const handleChange = (name, value) => {
        let frm = {...form};
        frm[name] = value;
        setForm(frm);
    }


    const handleGet = () => {

        setLoading(true);

        new Api().get('/discount').then((response) => {
            if (typeof response != "undefined") {
                setData(response.data)
            }
            setLoading(false);
        })

    }
    const shamsiToMiladi = (value) => {
        let y
        y = value && jalaali.toGregorian(value["year"], value["month"], value["day"])
        let date = y && Object.values(y).join("-")

        return date
    }

    const validation = () => {
        // if(typeof form.code === "undefined" || form.code?.length < 8) {
        //     toast.error("کد تخفیف باید بزرگتر از 8 رقم باشد");
        //     return false
        // }
        if((typeof form.discount === "undefined" || form.discount === "") && (typeof form.discount_percent === "undefined" || form.discount_percent === "")) {
            toast.error("مقدار تخفیف را وارد کنید");
            return false
        }
        // if(typeof form.code === "undefined" || form.code?.length < 8) {
        //     toast.error("کد تخفیف باید بزرگتر از 8 رقم باشد");
        //     return false
        // }
        if(typeof form.max_discount === "undefined" || form.max_discount === "") {
            toast.error("حداکثر مبلغ تخفیف در هر سفارش");
            return false
        }
        if(typeof form.minimum_order_cost === "undefined" || form.minimum_order_cost === "") {
            toast.error("حداقل خرید در هر سفارش");
            return false
        }
        if(typeof form.usable_number === "undefined" || form.usable_number === "") {
            toast.error("تعداد دفعات مورد استفاده");
            return false
        }
        if(typeof form.begin_at === "undefined" || form.begin_at === "") {
            toast.error("تاریخ شروع");
            return false
        }
        if(typeof form.expired_at === "undefined" || form.expired_at === "") {
            toast.error("تاریخ انقضا");
            return false
        }
        if(checked && tree.checked?.length === 0) {
            toast.error("دسته بندی مورد نظر را انتخاب کنید");
            return false
        }
        return true
    }
    const handleSubmit = async (event) => {
        event.preventDefault();

        // if(!validation())
        //     return false


        let items = []
        await form["products"]?.forEach((item) => {
            items.push(item?.id || item)
        })
        form["products"] = items

        setLoading(true);
        let arrTree = []
        let arrProduct = []
        let arr = []
        await tree?.checked?.forEach((item) => {
            arrTree.push({
                "category_id": item
            })
        })
        await form["products"]?.forEach((item) => {
            arrProduct.push({
                "product_id": item
            })
        })
        if(checked) {
            arr = [...arrTree]
        } else {
            arr = []
        }
        if(form["products"]) {
            arr = [...arr ,...arrProduct]
        }
        new Api().post('/discount', {
            "name": "vatan",
            "code": form.code,
            "discount_percent": form.discount_percent,
            "discount": form.discount,
            "max_discount": form.max_discount,
            "minimum_order_cost": form.minimum_order_cost,
            "usable_number": form.usable_number,
            "expired_at": shamsiToMiladi(form.expired_at),
            "category_and_products":arr
        }, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    handleGet()
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
        })
    }


    const handleDelete = (id) => {
        setLoading(true);
        new Api().delete(`/discount/${id}`).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    handleGet()
                } else {
                    toast.error(response.msg);

                }
            }
            setLoading(false);
        })

    }

    const handleChangeStatue = (id) => {
        new Api().put(`/discount/${id}/status`).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    handleGet()
                } else {
                    toast.error(response.msg);
                }
            }
        })
    }


    return (
        <Container>
            <Head data={{'link': '/discount', 'title': 'ایجاد کد تخفیف'}}/>
            <Box>
                <form onSubmit={handleSubmit}>
                    <Paper  style={{padding: '30px 20px'}}>
                        <Container>
                            <Grid xs={12}>
                                <div>
                                    <Grid container spacing={2}>
                                        <Grid xs={12}>
                                            <Grid item xs={12}>
                                                {
                                                    <Grid sm={12} container spacing={2}>
                                                        <Grid item sm={3}>
                                                            <TextField
                                                                label="تعریف کد"
                                                                variant="outlined"
                                                                margin='dense'
                                                                value={form.code}
                                                                fullWidth
                                                                name='code'
                                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item sm={3}>
                                                            <TextField
                                                                placeholder={`${form.discount ? "تخفیف به ریال فعال است":""}`}
                                                                disabled={form.discount}
                                                                label="مقدار تخفیف به درصد "
                                                                variant="outlined"
                                                                margin='dense'
                                                                value={form.discount_percent}
                                                                fullWidth
                                                                name='discount_percent'
                                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />

                                                        </Grid>
                                                        <Grid item sm={3}>
                                                            <TextField
                                                                placeholder={`${form.discount_percent ? "تخفیف به درصد فعال است":""}`}
                                                                disabled={form.discount_percent}
                                                                label="مقدار تخفیف به ریال "
                                                                variant="outlined"
                                                                margin='dense'
                                                                value={form.discount}
                                                                fullWidth
                                                                name='discount'
                                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />

                                                        </Grid>
                                                        <Grid item sm={3}>
                                                            <TextField
                                                                label="حداکثر مبلغ تخفیف در هر سفارش"
                                                                variant="outlined"
                                                                margin='dense'
                                                                value={form.max_discount}
                                                                fullWidth
                                                                name='max_discount'
                                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />

                                                        </Grid>
                                                        <Grid item sm={3}>
                                                            <TextField
                                                                label="حداقل خرید"
                                                                variant="outlined"
                                                                margin='dense'
                                                                value={form.minimum_order_cost}
                                                                fullWidth
                                                                name='minimum_order_cost'
                                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />

                                                        </Grid>
                                                        <Grid item sm={3}>
                                                            <TextField
                                                                label="تعداد دفعات مورد استفاده"
                                                                variant="outlined"
                                                                margin='dense'
                                                                value={form.usable_number}
                                                                fullWidth
                                                                name='usable_number'
                                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item sm={3}>
                                                            <div style={{width: "100%" , marginTop:"8px"}} className='datepicker-input-container'>
                                                                <DatePicker
                                                                    inputPlaceholder={"تاریخ شروع"}
                                                                    value={form.begin_at}
                                                                    onChange={(value) => handleChange('begin_at', value)}
                                                                    shouldHighlightWeekends
                                                                    locale="fa" // add this
                                                                />
                                                            </div>
                                                        </Grid>
                                                        <Grid item sm={3}>
                                                            <div style={{width: "100%", marginTop:"8px"}} className='datepicker-input-container'>
                                                                <DatePicker
                                                                    inputPlaceholder={"تاریخ انقضا"}
                                                                    value={form.expired_at}
                                                                    onChange={(value) => handleChange('expired_at', value)}
                                                                    shouldHighlightWeekends
                                                                    locale="fa" // add this
                                                                />
                                                            </div>
                                                        </Grid>

                                                    </Grid>

                                                }
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </div>
                            </Grid>
                            <Grid  xs={10}>
                                <Grid  style={{marginTop: '15px'}} component="label" container alignItems="center" spacing={1}>
                                    <Grid  item>انتخاب شده برای تمام محصولات</Grid>
                                    <Grid item>
                                        <Switch
                                            onChange={() => {
                                                setChecked(!checked);
                                            }}
                                            checked={checked} // relevant state for your case
                                            value="checked" // some value you need
                                        />
                                    </Grid>
                                    <Grid item>انتخاب دسته بندی</Grid>
                                </Grid>
                                {
                                    checked &&
                                    <div>
                                        <Tree nodes={tree.nodes} />
                                    </div>
                                }

                            </Grid>
                            <SelectProduct title={"محصولات "}
                                           type ={"product"}
                                           state={"products"}
                                           list = {productReducer}
                                           formData={form}
                                           onchange={(items) => form.products = items.products}
                            />


                            {Boolean(authReducer.user.permissions.setting.update_setting_admin.access) && <Grid item xs={12}>
                                <Button
                                    disabled={loading}
                                    style={{marginTop: '15px'}}
                                    type="submit"
                                    variant="contained"
                                    color={"primary"}
                                >
                                    ایجاد کد جدید
                                </Button>
                            </Grid>
                            }
                        </Container>
                    </Paper>
                </form>
                {loading && <Loading/>}

            </Box>

            <Box>
                {
                    data?.length > 0 &&
                    <form onSubmit={handleDelete}>
                        <Paper style={{padding: '30px 20px', marginTop: '15px'}}>
                            <Grid container spacing={2}>
                                <Grid xs={12}>
                                    <Grid item xs={12}>
                                        {
                                            <div style={{overflowX: 'auto'}}>
                                                <table className='table'>
                                                    <thead>
                                                    <tr>
                                                        <th>کد</th>
                                                        <th>تخفیف به درصد</th>
                                                        <th>تخفیف به ریال</th>
                                                        <th>مبلغ تخفیف در هر سفارش</th>
                                                        <th>دفعات مورد استفاده</th>
                                                        <th>تاریخ شروع</th>
                                                        <th>تاریخ پایان</th>
                                                        <th>وضعیت</th>
                                                        <th>حذف</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {data?.map((item, index) => {
                                                            return (
                                                                <tr>
                                                                    <td>{item.code}</td>
                                                                    <td>{item.discount_percent}</td>
                                                                    <td>{item.discount}</td>
                                                                    <td>{item.max_discount}</td>
                                                                    <td>{item.usable_number}</td>
                                                                    <td>{moment(item.begin_at).locale('fa').format('jYYYY/jMM/jDD')}</td>
                                                                    <td>{moment(item.expired_at).locale('fa').format('jYYYY/jMM/jDD')}</td>
                                                                    <td>
                                                                        <Tooltip title="وضعیت">
                                                                            <Chip size={"small"} variant={"outlined"} color={item.status ? "primary": "secondary"}  label={item.status ? 'فعال' : 'غیر فعال'} clickable={true} onClick={() => handleChangeStatue(item.id)} />
                                                                        </Tooltip>
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            Boolean(authReducer.user.permissions.setting.update_setting_admin.access) &&
                                                                            <IconButton onClick={() => handleDelete(item.id)}
                                                                                        color='secondary'>
                                                                                <RemoveCircleIcon/>
                                                                            </IconButton>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>

                    </form>
                }

                {loading && <Loading/>}
            </Box>
        </Container>
    );
}

const mapStateToProps = state => ({
    settingReducer: state.settingReducer,
    authReducer: state.authReducer
})

export default connect(mapStateToProps)(Discount);
